/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBioMatrixScanReward.vue?vue&type=template&id=4009e9ea&scoped=true"
import script from "./popBioMatrixScanReward.vue?vue&type=script&lang=js"
export * from "./popBioMatrixScanReward.vue?vue&type=script&lang=js"
import style0 from "./popBioMatrixScanReward.vue?vue&type=style&index=0&id=4009e9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4009e9ea",
  null
  
)

export default component.exports